export default __webpack_public_path__ + "static/media/edu-4.2b813420.jpg";